import type { PropsWithChildren } from 'react';

export function UnorderedList({ children }: PropsWithChildren): React.ReactElement {
  return <ul className="list-inside list-disc ml-4">{children}</ul>;
}
